
/* eslint-disable @typescript-eslint/no-shadow */
export namespace GridSingleSelectGraphTypeV1 {
  export enum GridSingleSelectGraphTypeV1 {
    PROPORTION = "PROPORTION",
    STACKED_COLUMN = "STACKED_COLUMN",
    GROUPED_BAR = "GROUPED_BAR",
    NONE = "NONE",
  }

  export interface GridSingleSelectGraphTypeV1DTO {
    case: string;
  }

  export const fromDTO = (dto: GridSingleSelectGraphTypeV1DTO): GridSingleSelectGraphTypeV1 => {
    if (dto === undefined || dto === null) {
      throw new InvalidGridSingleSelectGraphTypeV1Error(
        `Invalid DTO ${dto} provided for GridSingleSelectGraphTypeV1.GridSingleSelectGraphTypeV1`
      );
    }
    switch (dto.case) {
      case "PROPORTION":
        return GridSingleSelectGraphTypeV1.PROPORTION;
      case "STACKED_COLUMN":
        return GridSingleSelectGraphTypeV1.STACKED_COLUMN;
      case "GROUPED_BAR":
        return GridSingleSelectGraphTypeV1.GROUPED_BAR;
      case "NONE":
        return GridSingleSelectGraphTypeV1.NONE;
      default:
        throw new InvalidGridSingleSelectGraphTypeV1Error(
          `Case ${dto.case} is not valid case of GridSingleSelectGraphTypeV1.GridSingleSelectGraphTypeV1`
        );
    }
  };

  export const toDTO = (gridSingleSelectGraphTypeV1: GridSingleSelectGraphTypeV1): GridSingleSelectGraphTypeV1DTO => {
    const enumDTO = {
      case: GridSingleSelectGraphTypeV1[gridSingleSelectGraphTypeV1],
    };
    return enumDTO;
  };
}

export class InvalidGridSingleSelectGraphTypeV1Error extends Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGridSingleSelectGraphTypeV1Error";
  }
}
export class InvalidGridSingleSelectGraphTypeV1ProportionError extends InvalidGridSingleSelectGraphTypeV1Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGridSingleSelectGraphTypeV1ProportionError";
  }
}

export class InvalidGridSingleSelectGraphTypeV1StackedColumnError extends InvalidGridSingleSelectGraphTypeV1Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGridSingleSelectGraphTypeV1StackedColumnError";
  }
}

export class InvalidGridSingleSelectGraphTypeV1GroupedBarError extends InvalidGridSingleSelectGraphTypeV1Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGridSingleSelectGraphTypeV1GroupedBarError";
  }
}

export class InvalidGridSingleSelectGraphTypeV1NoneError extends InvalidGridSingleSelectGraphTypeV1Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGridSingleSelectGraphTypeV1NoneError";
  }
}
